import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TKaisyaListGetReq, TKaisyaListGetRes } from "./TKaisya"

/**
 * 会社マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class KaisyaService
 * @extends {ConnectApi}
 */
export default class KaisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TKaisyaListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaisyaListGetRes>> =
        await this.getInner(`/master/kaisya`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}
